export const habaAddress = {
  habaAddressForm: {
    invoiceCustomerCustomEmailLabel: 'Different email address',
    customerBenefitsTitle: 'Benefits of your user account',
    customerBenefitsEmailItem: 'Pay by invoice',
    customerBenefitsMapPinItem: 'Manage multiple delivery and billing addresses',
    customerBenefitsDeliveryTruckItem: 'Track delivery status and view your complete order history',
    customerBenefitsDeliveryInfoItem: 'Request non-binding, personalized pre-quotes',
    customerBenefitsDeliveryHeartItem: 'Create multiple wish lists',
    warningBannerTitle: 'Important',
    warningBannerMsg: {
      private: 'Please provide your customer number if available (e.g. from previous orders).',
      institution: "Please provide the official name of your institution and your customer number if available (e.g. from previous orders)",
      carrier: "Please provide the official name of the carrier and your customer number if available (e.g. from previous orders)",
      association: "Please provide the official name of your association and your customer number if available (e.g. from previous orders)",
      company: "Please provide the official name of your company and your customer number if available (e.g. from previous orders)",
    },

    defaultEmployeeInfoSectionAddressTitle: 'Your customer data',
    institutionEmployeeInfoSectionAddressTitle: 'Your data as an employee of the institution',
    carrierEmployeeInfoSectionAddressTitle: 'Your data as an employee of the carrier',
    carrierEmployeeInfoSectionAddressSubTitle: 'These are your registration details. You are the contact person for orders placed with this user account',
    associationEmployeeInfoSectionAddressTitle: 'Your data as a member of the club',
    companyEmployeeInfoSectionAddressTitle: 'Your data as an employee of the company',
    privateEmployeeInfoSectionAddressTitle: 'Your data as a private customer',
    defaultOrganizationDetailsSectionAddressTitle: 'Details of your institution',
    defaultOrganizationDetailsSectionAddressSubtitle: 'please provide us with the data for your invoice.',
    organizationDetailsSectionAddressInfo: {
      DE: 'Orders are only permitted in Germany.',
      AT: 'Orders are only permitted in Austria.',
    },
    deviatingDeliveryAddressInfo: {
      DE: 'Billing recipients are only permitted in Germany.',
      AT: 'Billing recipients are only permitted in Austria.',
    },
    institutionOrganizationDetailsSectionAddressTitle: 'Details of your institution',
    carrierOrganizationDetailsSectionAddressTitle: 'Details of the carrier',
    associationOrganizationDetailsSectionAddressTitle: 'Details of your club',
    companyOrganizationDetailsSectionAddressTitle: 'Details of the company',
    privateOrganizationDetailsSectionAddressTitle: 'Billing details',
    deliverAndInvoiceClosedSectionAddressTitle: 'Billing and delivery',
    deliveryFormAddressTitle: 'Where should the delivery be made?',
    deliveryFormNewAddressRadioLabel: 'Different delivery address',
    deliveryFormNewAddressInfo: {
      DE: 'Deliveries are only possible within Germany.',
      AT: 'Deliveries are only possible within Austria.',
    },
    billingFormNewAddressInfo:{
      DE: 'Invoice recipients are exclusively permitted within Germany.',
      AT:'Invoice recipients are exclusively permitted within Austria.',
    },
    deliveryFormPhoneDataTitle: 'Who is the contact person for this delivery?',
    deliveryFormPhoneDataSubTitle: 'In the case of a freight delivery, we will contact you before delivery.',
    deliveryFormPhoneDataRegistrationTitle: 'Who is the contact person for deliveries?',
    deliveryFormNewPhoneDataRadioLabel: 'Different contact person',
    deliverySectionAddressTitle: 'Delivery',
    invoiceSectionAddressTitle: 'Billing',
    invoiceSectionAddressSubtitle: 'Do you need a customized invoice delivery or invoice recipient, e.g. does your carrier pay the invoice?',
    customerTypeSectionAddressTitle: 'Type of your user account',
    customerTypeSectionAddressSubTitle:
      'Please indicate whether you are registering for an organisation or privately',
    clientPersonTitle: 'You are the contact person for this order.',
    shippingTitle: 'To which address should the delivery be made?',
    emailTitle: 'We will send the invoice exclusively to the email address provided here.',
    billingTitle: 'Which invoice recipient should be listed on the invoice?',
    deviatingAddressLabel: 'Different invoice recipient',
    deviatingEmail: {
      title: "To which email address should the invoice be sent?",
      subtitle: "We will send the invoice exclusively to the email address provided here."
    },
    deviatingAddress: {
      title: "Who should be listed as the invoice recipient on the invoice (the goods recipient is also listed in the invoice header)?",
    },
    gtcHtml:
      'I acknowledge the <span style="text-decoration: underline;">Privacy Policy</span> as well as the <span style="text-decoration: underline;">Terms and Conditions</span> of HABA Pro. By law, you have a 14-day right of withdrawal. Details and exceptions can be found in our cancellation policy.',
    newsletter: 'I would like to subscribe to the HABA Pro newsletter.',
    nextLabel: 'Next',
    requiredLabel: 'Required field',
    heading: 'Shipping address',
    backWithoutChanges: 'Back without Changes',
    customerType: {
      institution: 'Institution (f.e. kindergarden, daycare, school)',
      carrier: 'Carrier (f.e. municipality, social association)',
      association: 'Association (f.e. Support association, sports association)',
      company:
        'Company (f.e. medical practices / healthcare facilities, architects, gardening and landscaping companies)',
      private: 'Private',
    },
    section: {
      billingAddress: 'Billing address',
      billingAddressQuestion: 'What is your address',
      billingAddressEdit: 'Edit billing address',
      billingAddressNew: 'Add billing address',
      shippingAddress: 'Shipping address',
      shippingAddressEdit: 'edit default delivery address',
      shippingAddressNew: 'Add new default shipping address',
      shippingAdressUpdate: 'Update Shipping Address',
      shippingAdressNext: 'Next',
    },
    personalData: 'What is your personal data?',
    form: {
      error: {
        streetNameOnAdditional: "It looks like the street name has been entered in both the “Street” and “Address Line 2” fields. To ensure accurate delivery, please use “Address Line 2” for additional details only (e.g. building, floor, room, c/o).",
        streetNrOnStreetName: "It appears that your browser’s address autofill may have populated some fields automatically. Kindly make sure that the “Street” field contains the street name only (without the house number).",
        postalCodeOnTown: "It looks like the postal code has been entered in both the “Postal Code” and “City” fields. Please enter the city name only in the “City” field to avoid processing delays.",
        duplicateCompanyName: "It appears that you have entered the same company name twice. Please remove any duplicate text. If your company name fits on the first line, you can leave the second line blank.",
      },
      client: 'Client*',
      clientSecondLine: "Client - Line 2",
      yourBillingAddress: 'Your Billing Address{*}',
      contact: 'Contact of the company / institution',
      addressType: {
        private: 'Private',
        firm: 'Company',
        institution: 'Institution',
        firmInstitution: 'Institution/Company',
      },
      privateCompanyToggle: {
        private: 'Private customer',
        company: 'Company customer',
      },
      title: {
        label: 'Title',
        error: 'Please select a title',
      },
      firstName: {
        label: 'Surname*',
        error: 'Please input a surname',
      },
      lastName: {
        label: 'Lastname*',
        error: 'Please input a lastname',
      },
      dateOfBirth: {
        label: 'Date of Birth*',
        invalidDate:
          'Please check your date of birth. The required minimum age has not been reached.',
      },
      companyName: {
        label: 'Company*',
        error: 'Please input a company name',
      },
      companyNameExtension: {
        label: 'Company name extension',
      },
      unverifiedCustomerId: {
        label: 'Unconfirmed customer number',
      },
      alreadyCustomer: {
        label: 'Already a customer at Wehrfritz, but no account in the online shop yet',
      },
      firmInstitutionName: {
        label: 'Institution/Company',
        error: 'Please input the name of the Institution/Company',
      },
      vatID: {
        label: 'Tax-ID',
        error: 'Please input a tax-ID name',
      },
      institution: {
        label: 'Institution',
      },
      street: {
        label: 'Street*',
        error: 'Please input a street',
      },
      streetNumber: {
        label: 'No.*',
        error: 'Please input a street number',
      },
      additionalAddressInfo: {
        label: 'Extra address',
      },
      country: {
        label: 'Country*',
        error: 'Please input a country',
      },
      city: {
        label: 'City*',
        error: 'Please input a city',
      },
      zipCode: {
        label: 'ZIP*',
        error: 'The ZIP code must be  {{length}} long.',
      },
      industry: {
        label: 'Industry*',
        error: 'Mandatory: Please select an industry type',
      },
      email: {
        label: 'Email address*',
      },
      password: {
        label: 'Password for your user account',
      },
      salutation: {
        label: 'Salutation',
        sir: 'Sir',
        madam: 'Madam',
        none: 'None',
        error: 'Please choose one',
      },
      phone: {
        prefix: 'Country code',
        label: 'Phone number',
        label2: 'Phone number - e.g. for questions about the order',
        labelMobile: 'Phone number*',
        error:
          'Please enter a valid phone number (7–20 characters; only digits and + - / , ( ) are allowed).',
        message: ' (for any questions about delivery)*',
      },
      birthDate: {
        label: 'BirthDate',
      },
      year: {
        label: 'Year*',
        error: 'Please enter Year',
      },
      month: {
        label: 'Month*',
        error: 'Please Enter Month',
      },
      day: {
        label: 'Day*',
        error: 'Please enter Day',
      },
      defaultDeliveryAddress: 'Set as my default delivery address',
      optional: '(optional)',
      useAsDeliveryAddress: 'Identical to the delivery address',
      labels: {
        institution: {
          name1: "Name of the institution*",
          name2: "Name of the institution - Line 2",
        },
        carrier: {
          name1: "Name of the carrier*",
          name2: "Name of the carrier - Line 2",
        },
        association: {
          name1: "Name of the association*",
          name2: "Name of the association - Line 2",
        },
        company: {
          name1: "Name of the company*",
          name2: "Name of the company - Line 2",
        },
        generic: {
          name1: "Goods recipient*",
          name2: "Goods recipient - Line 2",
        },
        deviating: {
          name1: "Invoice recipient*",
          name2: "Invoice recipient - Line 2",
        }
      }
    },
    continueAsGuest: "Order as a guest (payment by invoice is not possible)",
    billingAddress: {
      selectAddress: 'Select the address associated with your card or payment method.',
      sameWithShippingAddress: 'Identical to the delivery address',
    },
    correctionDialog: {
      title: 'Confirm address',
      subtitle: 'We have detected a possible discrepancy. Please briefly check the recommended address.',
      yourInput: 'Your input',
      recommendedAddress: 'Recommended address',
      acceptBtn: 'Keep my input'
    },
  },

  habaAddressMelissa: {
    heading: 'Address verification',
    paragraph:
      'Dear customer, unfortunately we do not know your address. Please check these address suggestions and confirm your address',
    suggestions: 'Did you mean:',
    yourInput: 'Your input:',
    submitButton: 'ACCEPT SELECTION & CONTINUE',
  },
};
